import AdminWaiverCard from "@/components/admin/AdminWaiverCard";
import Header from "@/components/Header"
import { Input } from "@/components/ui/input";
import { AdminWaiversResponse } from "@/constants";
import { apiFetch } from "@/utils";
import { useEffect, useState } from "react"
import useSWR from "swr";

const AdminMembershipsPage: React.FC = () => {
	const [search, setSearch] = useState('');

	const { data: waiversResponse, mutate } = useSWR<AdminWaiversResponse>('/v1/admin/waivers', async () => {
		const params = new URLSearchParams();

		if(search) {
			params.append('searchTerm', search);
		}

		params.append('pageSize', '100');

		const qs = params.toString();

		const response = await apiFetch(`/v1/admin/waivers?${qs}`, {
			withCredentials: true
		});

		return response.json();
	})


	//TODO: add debounce to the search input
	useEffect(() => {
		mutate();
	}, [search]);

	const waivers = waiversResponse?.data ?? [];

	// Group by membershipId
	const groupedMemberships = waivers.reduce((acc: any, waiver) => {
		const membershipId = waiver.membershipId;
		if(!acc[membershipId]) {
			acc[membershipId] = {
				membership: waiver.membership,
				fullName: waiver.fullName,
				emailAddress: waiver.emailAddress,
				phoneNumber: waiver.phoneNumber,
				customerAddress: waiver.customerAddress,
				waivers: {}
			};
		}
		acc[membershipId].waivers[waiver.type] = waiver;
		return acc;
	}, {} as any);

	return <>
		<Header/>
		<div className="container mx-auto p-4 max-w-4xl">
			<div className="flex justify-between items-center mb-6">
				<h1 className="text-3xl font-bold">Memberships</h1>
			</div>
			<Input value={search} onChange={
				(e) => {
					setSearch(e.target.value);
				}
			} placeholder="Search memberships (email, customer address, full name, phone)..."/>

			<div className="flex flex-col gap-2 mt-8">
				{Object.values(groupedMemberships).map((group, index) =>
					<AdminWaiverCard groupedMembership={group} key={index}/>
				)}
			</div>
		</div>
	</>
}

export default AdminMembershipsPage